export const TRANSPORTATION_MODE_NAMES = {
  HEAVY_RAIL: 'Tåg',
  COMMUTER_TRAIN: 'Pendeltåg',
  SUBWAY: 'Tunnelbana',
  TRAM: 'Spårvagn',
  BUS: 'Buss',
  FERRY: 'Båt',
  CABLE_CAR: 'Linjebuss',
  GONDOLA_LIFT: 'Linbana',
  FUNICULAR: 'Kabelbana',
  HIGH_SPEED_TRAIN: 'Höghastighetståg',
  LONG_DISTANCE_TRAIN: 'Fjärrtåg',
  INTERCITY_BUS: 'Intercitybuss',
  TAXI: 'Taxi',
  RAIL: 'Tåg',
  TRANSIT: 'Kollektivtrafik',
  WALKING: 'Promenad',
  BICYCLING: 'Cykel',
  DRIVING: 'Bil',
};

export const replaceAllTransportationModeNames = (text: string) => {
  let result = text;
  for (const [key, value] of Object.entries(TRANSPORTATION_MODE_NAMES)) {
    result = result.replaceAll(key, value);
  }
  return result;
};
